import { ClientCreation, ClientRaw } from '@Arti-zen/package-backoffice'
import { Dialog } from '@mui/material'
import ClientListTable from '../ClientListTable'
import styled from 'styled-components'
import { Theme } from 'theme/theme'
import { Visibility } from '@mui/icons-material'
import { ErrorMessage } from 'modules/artisan/components/ArtisanUpload'
import { useState } from 'react'
import { Title } from './ClientsAfterUploading'

type TProps = {
  duplicates: ClientRaw[]
  onModify: boolean
}

export default function SeeDuplicates({ duplicates, onModify }: TProps) {
  const [openDialog, setOpenDialog] = useState<boolean>(false)

  return (
    <>
      {duplicates.length > 0 && (
        <Row>
          {onModify ? (
            <ErrorMessage>{duplicates.length} clients sont en doublon sur l'ID client.</ErrorMessage>
          ) : (
            <p>{duplicates.length} clients en doublon ont été écartés.</p>
          )}
          <SeeButton onClick={() => setOpenDialog(true)}>
            <Visibility color="inherit" fontSize="inherit" />
          </SeeButton>
        </Row>
      )}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="lg"
        PaperProps={{
          sx: {
            height: '80%',
          },
        }}
      >
        <ContainerDialog>
          <Title>Clients en doublon</Title>
          <ClientListTable
            data={duplicates as unknown as ClientCreation[]}
            correctClient={() => {}}
            openForm={() => {}}
            replaceAllErrors={() => {}}
            onModify={onModify}
          />
        </ContainerDialog>
      </Dialog>
    </>
  )
}

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
`

const SeeButton = styled.div`
  background-color: ${Theme.colors.blueArtizen};
  color: white;
  padding: 5px;
  border-radius: 50%;
  height: 15px;
  width: 15px;
  font-size: 15px;
  &:hover {
    opacity: 0.6;
    cursor: pointer;
  }
`

const ContainerDialog = styled.div`
  padding: 50px;
  height: 100%;
  display: flex;
  flex-direction: column;
`
